import PropTypes from 'prop-types'
import React, {useCallback, useEffect, useState} from 'react'

import {
    List,
    SimpleGrid,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {styleConfigChakraKeys} from '../../constants'
import MegaLink from './mega-link'

export default function MegaNavLinks({items, onClose}) {
    const styles = useMultiStyleConfig(styleConfigChakraKeys.megaLink)
    const [displayColumnTwo, setDisplayColumnTwo] = useState(true)
    const [displayColumnThree, setDisplayColumnThree] = useState(true)
    const [secondCategoryColumn, setSecondCategoryColumn] = useState([])
    const [thirdCategoryColumn, setThirdCategoryColumn] = useState([])
    const [activeLinkId, setActiveLinkId] = useState('')
    const [activeLinkId2, setActiveLinkId2] = useState('')
    const [activeLinkId3, setActiveLinkId3] = useState('')

    const handleColumn1LinkClick = useCallback(
        (data) => {
            setDisplayColumnTwo(false)
            setSecondCategoryColumn(JSON.parse(JSON.stringify(data)))
            setThirdCategoryColumn([])
        },
        [setSecondCategoryColumn, setThirdCategoryColumn]
    )

    const handleColumn2LinkClick = useCallback(
        (data) => {
            setDisplayColumnThree(false)
            setThirdCategoryColumn(JSON.parse(JSON.stringify([])))
            setTimeout(() => {
                setThirdCategoryColumn(JSON.parse(JSON.stringify(data)))
            }, 100)
        },
        [setThirdCategoryColumn]
    )

    const handleClearActiveLinkId2 = useCallback(() => {
        setActiveLinkId2('')
    }, [])

    const handleClearActiveLinkId3 = useCallback(() => {
        setActiveLinkId3('')
    }, [])

    useEffect(() => {
        setDisplayColumnTwo(true)
    }, [secondCategoryColumn, displayColumnTwo])

    useEffect(() => {
        setDisplayColumnThree(true)
    }, [thirdCategoryColumn, displayColumnThree])

    return (
        <SimpleGrid
            spacing="21px"
            justifyContent="left"
            width="53%"
            gridTemplateColumns="193px minmax(220px, 236px) minmax(220px, 236px)"
            paddingBottom="27px"
            minHeight="251px"
        >
            <List {...styles.listMenuColumn}>
                {items?.map(({sys, fields: item}, iValue) => {
                    const activeLink = item?.active ?? true

                    return (
                        <MegaLink
                            item={{...item, sys, isDisabled: !activeLink}}
                            active={activeLink}
                            isLink={sys?.contentType?.sys?.id === 'link'}
                            onLinkClick={onClose}
                            setNextCategoryColumn={handleColumn1LinkClick}
                            iValue={iValue}
                            key={sys?.id}
                            activeLinkId={activeLinkId}
                            setActiveLinkId={setActiveLinkId}
                        />
                    )
                })}
            </List>
            {secondCategoryColumn?.length > 0 && (
                <List
                    {...styles.listMenuColumn}
                    display={displayColumnTwo ? 'block' : 'none'}
                >
                    {secondCategoryColumn?.map(
                        ({sys, fields: item}, iValue) => (
                            <MegaLink
                                item={{
                                    ...item,
                                    sys
                                }}
                                isLink={sys?.contentType?.sys?.id === 'link'}
                                onLinkClick={onClose}
                                setNextCategoryColumn={handleColumn2LinkClick}
                                iValue={iValue}
                                key={sys?.id}
                                activeLinkId={activeLinkId2}
                                setActiveLinkId={handleClearActiveLinkId2}
                            />
                        )
                    )}
                </List>
            )}

            {thirdCategoryColumn?.length > 0 && (
                <List
                    {...styles.listMenuColumn}
                    display={displayColumnThree ? 'block' : 'none'}
                >
                    {thirdCategoryColumn?.map(({sys, fields: item}, iValue) => (
                        <MegaLink
                            item={{
                                ...item,
                                sys
                            }}
                            isLink={sys?.contentType?.sys?.id === 'link'}
                            onLinkClick={onClose}
                            iValue={iValue}
                            key={sys?.id}
                            activeLinkId={activeLinkId3}
                            setActiveLinkId={handleClearActiveLinkId3}
                        />
                    ))}
                </List>
            )}
        </SimpleGrid>
    )
}

MegaNavLinks.propTypes = {
    items: PropTypes.array,
    onClose: PropTypes.func
}
